package kz.dentalcrm.app.screens.quick_replies.list.mvi

import androidx.compose.runtime.Immutable
import kotlinx.collections.immutable.PersistentList
import kotlinx.collections.immutable.persistentListOf
import kz.dentalcrm.app.core.base.ViewState
import kz.dentalcrm.app.data.network.response_model.quick_replies.QuickReply

@Immutable
data class QuickRepliesViewState(
    val quickReplies: PersistentList<QuickReply> = persistentListOf(),
    val search: String = "",
    val screenState: ScreenState = ScreenState.Idle
) : ViewState {

    sealed interface ScreenState {
        data object Idle : ScreenState
        data object Loading : ScreenState
        data class Error(val text: String) : ScreenState
    }
}
